<template>
  <div>
    <div class="q-mx-md q-mt-sm q-pa-md bg-grey-2 rounded-borders">
      <p class="text-bold text-subtitle1">编辑样本信息</p>
      <!-- 样本信息 -->
      <div class="row items-center">
        <div
          class="
            bg-blue-6
            text-white
            q-mr-lg q-mb-md
            row
            justify-center
            items-center
          "
          :style="{
            borderRadius: '35%',
            width: '48px',
            height: '48px',
          }"
        >
          <q-icon name="fas fa-city" size="18px" />
        </div>
        <div v-if="sample.detail">
          <ul>
            <span class="text-bold q-mb-sm">名称：</span>
            {{
              sample.detail.name
            }}
          </ul>
          <ul>
            <span class="text-bold q-mb-sm">备注信息：</span
            >{{
              sample.detail.member_note
                ? sample.detail.member_note
                : "暂无备注信息"
            }}
          </ul>
          <!-- label bar -->
          <div class="q-mb-sm row items-center">
            <show-image-button
              v-if="sample || hasImage"
              :hasImage="hasImage"
              :sample="sample"
            />
            <q-chip
              v-for="label in sample.labels"
              :key="label.id"
              color="primary"
              class="text-white"
              dense
              size="md"
              :removable="label.user_can_edit ? true : false"
              @remove="removeLabel(label)"
            >
              <span style="font-size: 8px">{{ label.description }}</span>
            </q-chip>
          </div>
        </div>
      </div>
      <!-- label -->
      <q-separator />
      <!-- edit label -->
      <p class="text-bold text-caption q-my-sm">
        添加标签 <span class="text-weight-light">(点击即可添加)</span>
      </p>

      <div class="q-mb-xs">
        <q-chip
          dense
          color="secondary"
          v-for="label in editableLabel"
          :key="label.id"
          class="text-white"
        >
          <q-btn flat @click="addLabel(label)">
            <span style="font-size: 0.8rem">{{ label.description }}</span>
          </q-btn>
        </q-chip>
      </div>
      <!-- edit notes -->
      <p class="text-bold text-caption q-my-sm">
        添加备注<span class="text-weight-light"
          >(为样本添加一些注释，便于管理)</span
        >
      </p>
      <q-input
        v-model="note"
        filled
        clearable
        autofocus
        dense
        type="textarea"
      />
      <div class="row justify-between q-mb-lg q-mt-sm">
        <q-file
          dense
          label="添加一些备注图片(如果需要)"
          outlined
          color="primary"
          style="max-width: 400px"
          v-model="file"
        >
        </q-file>

        <q-btn
          rounded
          flat
          class="bg-primary text-white q-px-sm"
          dense
          @click="saveNotes"
          :disable="note===''"
        >
          <q-icon name="fas fa-check" size="13px" class="q-mr-sm" />
          <span>完成</span>
        </q-btn>
      </div>
      <div style="height: 40px; margin-bottom: 20px"></div>
    </div>
  </div>
</template>
<script>
import { EventBus } from "@/bus";
import { SAMPLE_INFO_CHANGED } from "@/bus/member.events";
import { uploadMemberAttachment } from "../../../api/endpoints/sample-detail/uploadMemberAttachment";
import { updateMemberNote } from "../../../api/endpoints/sample-detail/updateMemberNote";
import { updateSampleLabel } from "@/api/endpoints/sample/updateSampleLabel";
import { removeSampleLabel } from "@/api/endpoints/sample/removeSampleLabel";

export default {
  components: {
    ShowImageButton: () => import("../components/ShowImageButton.vue"),
  },
  props: {
    editableLabel: {
      type: Array,
      default: [],
    },
    sample: {},
  },
  data() {
    return {
      note: "",
      file: null,
    };
  },

  computed: {
    hasImage() {
      return this.sample.detail.member_attachment_urls !== null;
    },
  },

  methods: {
    async saveNotes() {
      try {
        if (this.file) {
          await this.upload();
        }
        await this.uploadNote(this.sample.detail.sample_id, this.note);
        EventBus.$emit(SAMPLE_INFO_CHANGED);
      } catch (error) {
        console.log(error);
        this.$q.notify({
          type: "danger",
          message: "出现错误",
        });
      }
    },
    async uploadNote(id, note) {
      try {
        const res = await updateMemberNote(id.toString(), note.toString());
        if (res.status || res.error) throw Error(res.detail || res.message);
        this.$q.notify({ type: "success", message: "信息已保存" });
      } catch (err) {
        this.$q.notify({ type: "danger", message: err.toString() });
      }
    },
    async upload() {
      const form = new FormData();

      form.append("attachmentFile", this.file);
      try {
        const response = await uploadMemberAttachment(
          this.sample.detail.sample_id,
          form
        );

        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.$q.notify({
            type: "success",
            message: "附件上传完成,点击 查看备注图片 查看",
          });
        }
        this.file = null;
      } catch {
        this.$q.notify({
          type: "danger",
          message: response.detail || response.message,
        });
      }
    },

    async addLabel(label) {
      if (
        this.sample.labels.some((sampleLabel) => {
          return sampleLabel.value === label.value;
        })
      ) {
        this.$q.notify({
          type: "warning",
          message: "该标签，已添加",
        });
        return;
      }
      // console.log(label)
      try {
        const response = await updateSampleLabel(this.sample.id, {
          value: label.value,
        });
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.$q.notify({
            type: "success",
            message: "添加成功",
          });
          EventBus.$emit(SAMPLE_INFO_CHANGED);
        }
      } catch (error) {
        this.$q.notify({ type: "danger", message: "更新标签出现错误" });
      }
    },

    async removeLabel(label) {
      // console.log("remove", label);
      try {
        const response = await removeSampleLabel(this.sample.id, {
          value: label.value,
        });
        EventBus.$emit(SAMPLE_INFO_CHANGED);
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.$q.notify({
            type: "success",
            message: "移除标签成功",
          });
        }
      } catch (error) {
        this.$q.notify({ type: "danger", message: "删除标签出现错误" });
      }
    },
  },
};
</script>
<style lang="">
</style>